import React from 'react';
import { Image } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import avatarIcon from '@/assets/images/default-user-icon.png';
import { avatarBackgroundColour, userInitials } from '../helper';

const UserImage = ({
  name,
  size,
  floated,
  className,
}) => {
  const intl = useIntl();
  return (
    <>
      <Image
        className={`${className} avatar-background-colour-${avatarBackgroundColour(name)}`}
        alt={intl.formatMessage({ id: 'header.user.avatar.alt' })}
        src={avatarIcon}
        floated={floated}
        size={size}
      />
      <div className="avatar-initials">
        {userInitials(name)}
      </div>
    </>
  );
};

export default UserImage;
